module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/189-equatorial-guinea-01b0263c8a839634b310c4055661b4ec.svg";